import { Box } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ModalTitle } from '../ModalTitle';
import { DeviceSelectionContainer } from '../DeviceSelectionContainer';

import styles from './SettingsMenu.module.scss';

type SettingsMenuProps = {
  onClose(): void;
  className?: string;
  withLayoutSelection?: boolean;
  withBackground?: boolean;
  forceLightTheme?: boolean;
};

export function SettingsMenu({
  className,
  withBackground,
  withLayoutSelection,
  onClose,
  forceLightTheme,
}: SettingsMenuProps) {
  const { t } = useTranslation('providerRoom');

  return (
    <>
      <Box
        className={classnames(styles.menu, className)}
        sx={(theme) => ({
          backgroundColor: forceLightTheme ? '#ffffff' : 'var(--app-surface)',
          color: forceLightTheme ? '#393534' : undefined,
          border: `1px solid ${
            forceLightTheme
              ? 'rgba(0, 0, 0, 0.08)'
              : theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.12)'
              : 'rgba(0, 0, 0, 0.08)'
          }`,
          boxShadow: forceLightTheme
            ? '0 12px 30px rgba(0, 0, 0, 0.18)'
            : theme.palette.mode === 'dark'
            ? '0 12px 30px rgba(0, 0, 0, 0.45)'
            : '0 12px 30px rgba(0, 0, 0, 0.18)',
          ...(forceLightTheme && {
            '& .MuiTypography-root': {
              color: '#393534',
            },
          }),
        })}
      >
        <ModalTitle title={t('menus.settings')} onClose={onClose} />
        <DeviceSelectionContainer
          withMasterVolume
          withBackground={withBackground}
          withLayoutSelection={withLayoutSelection}
          // withThemeSelection
          withAudioDiagnostic
          inlineAudioDiagnostic
          microphoneFirst
          forceLightTheme={forceLightTheme}
        />
      </Box>
    </>
  );
}
